const TAB_SKELETON_WIDTHS = ['w-[72px]', 'w-[96px]', 'w-[80px]', 'w-[104px]'] as const;

export const loadingStateStyles = {
	tabsRow: 'mb-6 flex flex-wrap gap-3',
	tabSkeleton: (index: number) =>
		`h-9 ${TAB_SKELETON_WIDTHS[index] ?? 'w-[88px]'} bg-[#ededf5] rounded-full animate-pulse`,
	listContainer: 'flex flex-col gap-6',
	cardSkeleton: 'h-[156px] bg-[#ededf5] rounded-2xl animate-pulse'
} as const;
